export default __webpack_public_path__ + "static/media/coinyoda.4d21461a.png";